import React, { useRef, useState, useEffect } from 'react';
import { Button, Modal, Checkbox } from 'tea-component';

import './index.scss';
import useIntlExtend from '@intelligence/hooks/useIntlExtend';

export const INTELLIGENCE_FILTER_MODAL_NO_LONGER_PROMPT =
  '__db_intelligence_filter_modal_no_longer_prompt__';

type Props = {
  visible?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

function FilterTipModal({ visible, onConfirm, onCancel }: Props) {
  const { formatMessage } = useIntlExtend();

  const [doNotShotAgain, setDoNotShotAgain] = useState<boolean>();

  // 是否有操作标识，有 confirm 确认/取消操作后禁止不再提示勾选框操作，避免确认时卡顿导致还可以勾选
  const hasConfirmedRef = useRef<boolean>(false);

  // 弹窗显隐状态变化后重置标识，避免标识状态留存
  useEffect(() => {
    hasConfirmedRef.current = false;
  }, [visible]);

  const saveNoLongerPrompt = () => {
    if (doNotShotAgain) {
      localStorage.setItem(INTELLIGENCE_FILTER_MODAL_NO_LONGER_PROMPT, '1');
    }
  };

  const handleConfirm = () => {
    hasConfirmedRef.current = true;
    onConfirm?.();
    saveNoLongerPrompt();
  };

  const handleCancel = () => {
    hasConfirmedRef.current = true;
    onCancel?.();
    saveNoLongerPrompt();
  };

  const handleCheckboxChange = (value: boolean) => {
    if (hasConfirmedRef.current) return;
    setDoNotShotAgain(value);
  };

  return (
    <Modal
      size={600}
      visible={visible}
      onClose={handleCancel}
      caption={formatMessage({ id: 'dbi_filter_modal_tips' }) as string}
      className="dbi_filter_tip_modal"
    >
      <Modal.Body>{formatMessage({ id: 'dbi_filter_modal_content' })}</Modal.Body>

      <Modal.Footer>
        <Button id="dbi_filter_modal_ok_btn" type="primary" onClick={handleConfirm}>
          {formatMessage({ id: 'dbi_filter_modal_ok' })}
        </Button>
        <Button id="dbi_filter_modal_cancel_btn" type="weak" onClick={handleCancel}>
          {formatMessage({ id: 'dbi_filter_modal_cancel' })}
        </Button>

        <div className="dbi_filter_modal_checkbox_container">
          <Checkbox
            className="dbi_filter_modal_checkbox"
            display="block"
            value={doNotShotAgain}
            onChange={handleCheckboxChange}
          >
            {formatMessage({ id: 'dbi_filter_modal_no_longer_prompt' })}
          </Checkbox>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default FilterTipModal;
